// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___2nX_f","editor":"styles__editor___1Xo_O","editorWrapper":"styles__editorWrapper___1ZvZN"};